import { useEffect, useMemo, useState } from 'react'

const getBrowserWindow = () => (globalThis as typeof globalThis & { window?: Window }).window

export default function useMediaQuery(query: string): boolean {
  const media = useMemo(() => {
    const browserWindow = getBrowserWindow()
    if (typeof browserWindow?.matchMedia !== 'function') {
      return null
    }
    return browserWindow.matchMedia(query.replace('@media', '').trim())
  }, [query])
  const [matches, setMatches] = useState(media?.matches ?? false)

  useEffect(() => {
    if (!media) {
      return
    }

    setMatches(media.matches)

    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    if (media.addEventListener) {
      media.addEventListener('change', listener)
    } else {
      media.addListener(listener)
    }

    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', listener)
      } else {
        media.removeListener(listener)
      }
    }
  }, [media, setMatches])

  return matches
}
